import { Directive, OnInit, inject, input } from '@angular/core';

import { ThemeInverse, injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { DsCardHeader } from '@frontend/ui/card-header';

import { CardThemeSurface } from './types';

@Directive({
    selector: '[msThemedCardHeader]',
})
export class SportsThemedCardHeaderDirective implements OnInit {
    themedSurface = input<CardThemeSurface>();
    themedInverse = input<ThemeInverse>();
    currentTheme = injectCurrentTheme();
    cardHeader: DsCardHeader = inject(DsCardHeader, {
        self: true,
    });

    ngOnInit(): void {
        const surface = this.themedSurface()?.[this.currentTheme];
        if (surface) {
            this.cardHeader.surface.set(surface);
        }

        const inverse = this.themedInverse()?.[this.currentTheme];
        if (inverse) {
            this.cardHeader.inverse.set(inverse.isInverse);
        }
    }
}
